import UAEFlag from '../assets/images/UAE.svg';
import UKFlag from '../assets/images/Mask-group.svg';
import SaudiFlag from '../assets/images/Saudi_Arabia.svg';
import USFlag from '../assets/images/US.svg';
import AustraliaFlag from '../assets/images/AU.svg';
import IndiaFlag from '../assets/images/IN.svg'; 
import GermanyFlag from '../assets/images/DE.svg';
import IrelandFlag from '../assets/images/IE.svg';
import FranceFlag from '../assets/images/FR.svg';
import AfghanistanFlag from '../assets/images/AF.svg';
import AlbaniaFlag from '../assets/images/AL.svg';
import AlgeriaFlag from '../assets/images/DZ.svg';
import AmericanSamoaFlag from '../assets/images/AS.svg';
import AndorraFlag from '../assets/images/AD.svg';
import AngolaFlag from '../assets/images/AO.svg';
import AnguillaFlag from '../assets/images/AI.svg';
import AntiguaAndBarbudaFlag from '../assets/images/AG.svg';
import ArgentinaFlag from '../assets/images/AR.svg';
import ArmeniaFlag from '../assets/images/AM.svg';
import ArubaFlag from '../assets/images/AW.svg';
import AustriaFlag from '../assets/images/AT.svg';
import AzerbaijanFlag from '../assets/images/AZ.svg';
import TheBahamasFlag from '../assets/images/BS.svg';
import BahrainFlag from '../assets/images/BH.svg';
import BangladeshFlag from '../assets/images/BD.svg';
import BarbadosFlag from '../assets/images/BB.svg';
import BelarusFlag from '../assets/images/BY.svg';
import BelgiumFlag from '../assets/images/BE.svg';
import BelizeFlag from '../assets/images/BZ.svg';
import BeninFlag from '../assets/images/BJ.svg';
import BermudaFlag from '../assets/images/BM.svg';
import BhutanFlag from '../assets/images/BT.svg';
import BoliviaFlag from '../assets/images/BO.svg';
import BosniaAndHerzegovinaFlag from '../assets/images/BA.svg';
import BotswanaFlag from '../assets/images/BW.svg';
import BrazilFlag from '../assets/images/BR.svg';
import BritishIndianOceanTerritoryFlag from '../assets/images/IO.svg';
import BruneiDarussalamFlag from '../assets/images/BN.svg';
import BulgariaFlag from '../assets/images/BG.svg';
import BurkinaFasoFlag from '../assets/images/BF.svg';
import BurundiFlag from '../assets/images/BI.svg';
import CambodiaFlag from '../assets/images/KH.svg';
import CameroonFlag from '../assets/images/CM.svg';
import CaboVerdeFlag from '../assets/images/CV.svg';
import CaymanIslandsFlag from '../assets/images/KY.svg';
import CentralAfricanRepublicFlag from '../assets/images/CF.svg';
import ChadFlag from '../assets/images/TD.svg';
import ChileFlag from '../assets/images/CL.svg';
import ChinaFlag from '../assets/images/CN.svg';
import ColombiaFlag from '../assets/images/CO.svg';
import ComorosFlag from '../assets/images/KM.svg';
import RepublicOfTheCongoFlag from '../assets/images/CG.svg';
import DemocraticRepublicOfTheCongoFlag from '../assets/images/CD.svg';
import CookIslandsFlag from '../assets/images/CK.svg';
import CostaRicaFlag from '../assets/images/CR.svg';
import CroatiaFlag from '../assets/images/HR.svg';
import CubaFlag from '../assets/images/CU.svg';
import RepublicOfTheCyprusFlag from '../assets/images/CY.svg';
import CzechRepublicFlag from '../assets/images/CZ.svg';
import IvoryCoastFlag from '../assets/images/CI.svg';
import DenmarkFlag from '../assets/images/DK.svg';
import DjiboutiFlag from '../assets/images/DJ.svg';
import DominicaFlag from '../assets/images/DM.svg';
import DominicanRepublicFlag from '../assets/images/DO.svg';
import EcuadorFlag from '../assets/images/EC.svg';
import EgyptFlag from '../assets/images/EG.svg';
import ElSalvadorFlag from '../assets/images/SV.svg';
import EquatorialGuineaFlag from '../assets/images/GQ.svg';
import EritreaFlag from '../assets/images/ER.svg';
import EstoniaFlag from '../assets/images/EE.svg';
import EthiopiaFlag from '../assets/images/ET.svg';
import FaroeIslandsFlag from '../assets/images/FO.svg';
import FijiFlag from '../assets/images/FJ.svg';
import FrenchGuianaFlag from '../assets/images/GF.svg';
import FrenchPolynesiaFlag from '../assets/images/PF.svg';
import GabonFlag from '../assets/images/GA.svg';
import TheGambiaFlag from '../assets/images/GM.svg';
import GeorgiaFlag from '../assets/images/GE.svg';
import GhanaFlag from '../assets/images/GH.svg';
import GibraltarFlag from '../assets/images/GI.svg';
import GreeceFlag from '../assets/images/GR.svg';
import GreenlandFlag from '../assets/images/GL.svg';
import GrenadaFlag from '../assets/images/GD.svg';
import GuamFlag from '../assets/images/GU.svg';
import GuatemalaFlag from '../assets/images/GT.svg';
import GuineaFlag from '../assets/images/GN.svg';
import GuineaBissauFlag from '../assets/images/GW.svg';
import GuyanaFlag from '../assets/images/GY.svg';
import HaitiFlag from '../assets/images/HT.svg';
import VaticanCityFlag from '../assets/images/VA.svg';
import HondurasFlag from '../assets/images/HN.svg';
import HongKongFlag from '../assets/images/HK.svg';
import HungaryFlag from '../assets/images/HU.svg';
import IcelandFlag from '../assets/images/IS.svg';
import IndonesiaFlag from '../assets/images/ID.svg';
import IranFlag from '../assets/images/IR.svg';
import IraqFlag from '../assets/images/IQ.svg';
import IsraelFlag from '../assets/images/IL.svg';
import ItalyFlag from '../assets/images/IT.svg';
import JamaicaFlag from '../assets/images/JM.svg';
import JapanFlag from '../assets/images/JP.svg';
import JordanFlag from '../assets/images/JO.svg';
import KenyaFlag from '../assets/images/KE.svg';
import KiribatiFlag from '../assets/images/KI.svg';
import NorthKoreaFlag from '../assets/images/KP.svg';
import SouthKoreaFlag from '../assets/images/KR.svg';
import KosovoFlag from '../assets/images/XK.svg';
import KuwaitFlag from '../assets/images/KW.svg';
import KyrgyzstanFlag from '../assets/images/KG.svg';
import LaosFlag from '../assets/images/LA.svg';
import LatviaFlag from '../assets/images/LV.svg';
import LebanonFlag from '../assets/images/LB.svg';
import LesothoFlag from '../assets/images/LS.svg';
import LiberiaFlag from '../assets/images/LR.svg';
import LibyaFlag from '../assets/images/LY.svg';
import LiechtensteinFlag from '../assets/images/LI.svg'; 
import LithuaniaFlag from '../assets/images/LT.svg';
// Add these imports after your existing flag imports
import LuxembourgFlag from '../assets/images/LU.svg';
import MacaoFlag from '../assets/images/MO.svg';
import NorthMacedoniaFlag from '../assets/images/MK.svg';
import MadagascarFlag from '../assets/images/MG.svg';
import MalawiFlag from '../assets/images/MW.svg';
import MalaysiaFlag from '../assets/images/MY.svg';
import MaldivesFlag from '../assets/images/MV.svg';
import MaliFlag from '../assets/images/ML.svg';
import MaltaFlag from '../assets/images/MT.svg';
import MarshallIslandsFlag from '../assets/images/MH.svg';
import MartiniqueFlag from '../assets/images/MQ.svg';
import MauritaniaFlag from '../assets/images/MR.svg';
import MauritiusFlag from '../assets/images/MU.svg';
import MexicoFlag from '../assets/images/MX.svg';
import MicronesiaFlag from '../assets/images/FM.svg';
import MoldovaFlag from '../assets/images/MD.svg';
import MonacoFlag from '../assets/images/MC.svg';
import MongoliaFlag from '../assets/images/MN.svg';
import MontenegroFlag from '../assets/images/ME.svg';
import MontserratFlag from '../assets/images/MS.svg';
import MozambiqueFlag from '../assets/images/MZ.svg';
import MyanmarFlag from '../assets/images/MM.svg';
import NamibiaFlag from '../assets/images/NA.svg';
import NauruFlag from '../assets/images/NR.svg';
import NepalFlag from '../assets/images/NP.svg';
import NetherlandsFlag from '../assets/images/NL.svg';
import NewCaledoniaFlag from '../assets/images/NC.svg';
import NicaraguaFlag from '../assets/images/NI.svg';
import NigerFlag from '../assets/images/NE.svg';
import NigeriaFlag from '../assets/images/NG.svg';
import NiueFlag from '../assets/images/NU.svg';
import NorfolkIslandFlag from '../assets/images/NF.svg';
import NorthernMarianaIslandsFlag from '../assets/images/MP.svg';
import OmanFlag from '../assets/images/OM.svg';
import PakistanFlag from '../assets/images/PK.svg';
import PalauFlag from '../assets/images/PW.svg';
import PalestineFlag from '../assets/images/PS.svg';
import PanamaFlag from '../assets/images/PA.svg';
import PapuaNewGuineaFlag from '../assets/images/PG.svg';
import ParaguayFlag from '../assets/images/PY.svg';
import PeruFlag from '../assets/images/PE.svg';
import PhilippinesFlag from '../assets/images/PH.svg';
import NewZealandFlag from '../assets/images/NZ.svg';
// import PitcairnIslandsFlag from '../assets/images/PN.svg';
import PolandFlag from '../assets/images/PL.svg';
import PortugalFlag from '../assets/images/PT.svg';
import PuertoRicoFlag from '../assets/images/PR.svg';
import QatarFlag from '../assets/images/QA.svg';
import RomaniaFlag from '../assets/images/RO.svg';
import RussiaFlag from '../assets/images/RU.svg';
import RwandaFlag from '../assets/images/RW.svg';
import ReunionFlag from '../assets/images/RE.svg';
import SaintHelenaFlag from '../assets/images/SH.svg';
import SaintKittsAndNevisFlag from '../assets/images/KN.svg';
import SaintLuciaFlag from '../assets/images/LC.svg';
import SaintMartinFlag from '../assets/images/MF.svg';
import SaintPierreAndMiquelonFlag from '../assets/images/PM.svg';
import SaintVincentAndTheGrenadinesFlag from '../assets/images/VC.svg';
import SamoaFlag from '../assets/images/WS.svg';
import SanMarinoFlag from '../assets/images/SM.svg';
import SaoTomeAndPrincipeFlag from '../assets/images/ST.svg';
import SenegalFlag from '../assets/images/SN.svg';
import SerbiaFlag from '../assets/images/RS.svg';
import SeychellesFlag from '../assets/images/SC.svg';
import SierraLeoneFlag from '../assets/images/SL.svg';
import SingaporeFlag from '../assets/images/SG.svg';
import SintMaartenFlag from '../assets/images/SX.svg';
import SlovakiaFlag from '../assets/images/SK.svg';
import SloveniaFlag from '../assets/images/SI.svg';
import SolomonIslandsFlag from '../assets/images/SB.svg';
import SomaliaFlag from '../assets/images/SO.svg';
import SouthAfricaFlag from '../assets/images/ZA.svg';
import FalklandIslandsFlag from '../assets/images/FK.svg';
import SouthSudanFlag from '../assets/images/SS.svg';
import SpainFlag from '../assets/images/ES.svg';
import SriLankaFlag from '../assets/images/LK.svg';
import SudanFlag from '../assets/images/SD.svg';
import SurinameFlag from '../assets/images/SR.svg';
import NorwayFlag from '../assets/images/NO.svg';
import SwazilandFlag from '../assets/images/SZ.svg';
import SwedenFlag from '../assets/images/SE.svg';
import SwitzerlandFlag from '../assets/images/CH.svg';
import SyriaFlag from '../assets/images/SY.svg';
import TaiwanFlag from '../assets/images/TW.svg';
import TajikistanFlag from '../assets/images/TJ.svg';
import TanzaniaFlag from '../assets/images/TZ.svg';
import ThailandFlag from '../assets/images/TH.svg';
import BonaireSintEustatiusAndSabaFlag from '../assets/images/BQ.svg';
import TimorLesteFlag from '../assets/images/TL.svg';
import TogoFlag from '../assets/images/TG.svg';
import TokelauFlag from '../assets/images/TK.svg';
import TongaFlag from '../assets/images/TO.svg';
import TrinidadAndTobagoFlag from '../assets/images/TT.svg';
import TunisiaFlag from '../assets/images/TN.svg';
import TurkeyFlag from '../assets/images/TR.svg';
import TurkmenistanFlag from '../assets/images/TM.svg';
import TurksAndCaicosIslandsFlag from '../assets/images/TC.svg';
import TuvaluFlag from '../assets/images/TV.svg';
import UgandaFlag from '../assets/images/UG.svg';
import UkraineFlag from '../assets/images/UA.svg';
import UruguayFlag from '../assets/images/UY.svg';
import UzbekistanFlag from '../assets/images/UZ.svg';
import VanuatuFlag from '../assets/images/VU.svg';
import VenezuelaFlag from '../assets/images/VE.svg';
import VietnamFlag from '../assets/images/VN.svg';
import BritishVirginIslandsFlag from '../assets/images/VG.svg';
import USVirginIslandsFlag from '../assets/images/VI.svg';
import WallisAndFutunaFlag from '../assets/images/WF.svg';
import MoroccoFlag from '../assets/images/MA.svg';
import YemenFlag from '../assets/images/YE.svg';
import ZambiaFlag from '../assets/images/ZM.svg';
import ZimbabweFlag from '../assets/images/ZW.svg';
import FinlandFlag from '../assets/images/FI.svg';


export const COUNTRY_DATA = [
  {code: '', svgPath: ''},
  { code: '+971', svgPath: UAEFlag },
  { code: '+1', svgPath: USFlag },
  { code: '+44', svgPath: UKFlag },
  { code: '+61', svgPath: AustraliaFlag},
  { code: '+91', svgPath: IndiaFlag },
  { code: '+49', svgPath: GermanyFlag },
  { code: '+966', svgPath: SaudiFlag },
  { code: '+353', svgPath: IrelandFlag },
  { code: '+33', svgPath: FranceFlag },
  { code: '+93', svgPath: AfghanistanFlag },
  { code: '+355', svgPath: AlbaniaFlag },
  { code: '+213', svgPath: AlgeriaFlag },
  { code: '+1684', svgPath: AmericanSamoaFlag },
  { code: '+376', svgPath: AndorraFlag },
  { code: '+244', svgPath: AngolaFlag },
  { code: '+1264', svgPath: AnguillaFlag },
  { code: '+1268', svgPath: AntiguaAndBarbudaFlag },
  { code: '+54', svgPath: ArgentinaFlag },
  { code: '+374', svgPath: ArmeniaFlag },
  { code: '+297', svgPath: ArubaFlag },
  { code: '+43', svgPath: AustriaFlag },
  { code: '+994', svgPath: AzerbaijanFlag },
  { code: '+1242', svgPath: TheBahamasFlag },
  { code: '+973', svgPath: BahrainFlag },
  { code: '+880', svgPath: BangladeshFlag },
  { code: '+1246', svgPath: BarbadosFlag },
  { code: '+375', svgPath: BelarusFlag },
  { code: '+32', svgPath: BelgiumFlag },
  { code: '+501', svgPath: BelizeFlag },
  { code: '+229', svgPath: BeninFlag },
  { code: '+1441', svgPath: BermudaFlag },
  { code: '+975', svgPath: BhutanFlag },
  { code: '+591', svgPath: BoliviaFlag },
  { code: '+387', svgPath: BosniaAndHerzegovinaFlag },
  { code: '+267', svgPath: BotswanaFlag },
  { code: '+55', svgPath: BrazilFlag },
  { code: '+246', svgPath: BritishIndianOceanTerritoryFlag },
  { code: '+673', svgPath: BruneiDarussalamFlag },
  { code: '+359', svgPath: BulgariaFlag },
  { code: '+226', svgPath: BurkinaFasoFlag },
  { code: '+257', svgPath: BurundiFlag },
  { code: '+855', svgPath: CambodiaFlag },
  { code: '+237', svgPath: CameroonFlag },
  { code: '+238', svgPath: CaboVerdeFlag },
  { code: '+1345', svgPath: CaymanIslandsFlag },
  { code: '+236', svgPath: CentralAfricanRepublicFlag },
  { code: '+235', svgPath: ChadFlag },
  { code: '+56', svgPath: ChileFlag },
  { code: '+86', svgPath: ChinaFlag },
  { code: '+57', svgPath: ColombiaFlag },
  { code: '+269', svgPath: ComorosFlag },
  { code: '+242', svgPath: RepublicOfTheCongoFlag },
  { code: '+243', svgPath: DemocraticRepublicOfTheCongoFlag },
  { code: '+682', svgPath: CookIslandsFlag},
  { code: '+506', svgPath: CostaRicaFlag },
  { code: '+385', svgPath: CroatiaFlag },
  { code: '+53', svgPath: CubaFlag },
  { code: '+357', svgPath: RepublicOfTheCyprusFlag },
  { code: '+420', svgPath: CzechRepublicFlag },
  { code: '+225', svgPath: IvoryCoastFlag },
  { code: '+45', svgPath: DenmarkFlag },
  { code: '+253', svgPath: DjiboutiFlag },
  { code: '+1767', svgPath: DominicaFlag },
  { code: '+1849', svgPath: DominicanRepublicFlag },
  { code: '+1829', svgPath: DominicanRepublicFlag },
  { code: '+1809', svgPath: DominicanRepublicFlag },
  { code: '+593', svgPath: EcuadorFlag },
  { code: '+20', svgPath: EgyptFlag },
  { code: '+503', svgPath: ElSalvadorFlag },
  { code: '+240', svgPath: EquatorialGuineaFlag },
  { code: '+291', svgPath: EritreaFlag },
  { code: '+372', svgPath: EstoniaFlag },
  { code: '+251', svgPath: EthiopiaFlag },
  { code: '+298', svgPath: FaroeIslandsFlag },
  { code: '+679', svgPath: FijiFlag },
  { code: '+594', svgPath: FrenchGuianaFlag },  
  { code: '+689', svgPath: FrenchPolynesiaFlag },
  { code: '+241', svgPath: GabonFlag },
  { code: '+220', svgPath: TheGambiaFlag },
  { code: '+995', svgPath: GeorgiaFlag },
  { code: '+233', svgPath: GhanaFlag },
  { code: '+350', svgPath: GibraltarFlag },
  { code: '+30', svgPath: GreeceFlag },
  { code: '+299', svgPath: GreenlandFlag },
  { code: '+1473', svgPath: GrenadaFlag },
  { code: '+1671', svgPath: GuamFlag },
  { code: '+502', svgPath: GuatemalaFlag },
  { code: '+224', svgPath: GuineaFlag },
  { code: '+245', svgPath: GuineaBissauFlag },
  { code: '+592', svgPath: GuyanaFlag },
  { code: '+509', svgPath: HaitiFlag },
  { code: '+379', svgPath: VaticanCityFlag },
  { code: '+504', svgPath: HondurasFlag },
  { code: '+852', svgPath: HongKongFlag },
  { code: '+36', svgPath: HungaryFlag },
  { code: '+354', svgPath: IcelandFlag },
  { code: '+62', svgPath: IndonesiaFlag },
  { code: '+98', svgPath: IranFlag },
  { code: '+964', svgPath: IraqFlag },
  { code: '+972', svgPath: IsraelFlag },
  { code: '+39', svgPath: ItalyFlag },
  { code: '+1876', svgPath: JamaicaFlag },
  { code: '+81', svgPath: JapanFlag },
  { code: '+962', svgPath: JordanFlag },
  { code: '+254', svgPath: KenyaFlag },
  { code: '+686', svgPath: KiribatiFlag },
  { code: '+850', svgPath: NorthKoreaFlag },
  { code: '+82', svgPath: SouthKoreaFlag },
  { code: '+383', svgPath: KosovoFlag },
  { code: '+965', svgPath: KuwaitFlag },
  { code: '+996', svgPath: KyrgyzstanFlag },
  { code: '+856', svgPath: LaosFlag },
  { code: '+371', svgPath: LatviaFlag },
  { code: '+961', svgPath: LebanonFlag },
  { code: '+266', svgPath: LesothoFlag },
  { code: '+231', svgPath: LiberiaFlag },
  { code: '+218', svgPath: LibyaFlag },
  { code: '+423', svgPath: LiechtensteinFlag },
  { code: '+370', svgPath: LithuaniaFlag },
 
  { code: '+352', svgPath: LuxembourgFlag },
  { code: '+853', svgPath: MacaoFlag },
  { code: '+389', svgPath: NorthMacedoniaFlag },
  { code: '+261', svgPath: MadagascarFlag },
  { code: '+265', svgPath: MalawiFlag },
  { code: '+60', svgPath: MalaysiaFlag },
  { code: '+960', svgPath: MaldivesFlag },
  { code: '+223', svgPath: MaliFlag },
  { code: '+356', svgPath: MaltaFlag },
  { code: '+692', svgPath: MarshallIslandsFlag },
  { code: '+596', svgPath: MartiniqueFlag },
  { code: '+222', svgPath: MauritaniaFlag },
  { code: '+230', svgPath: MauritiusFlag },
  { code: '+52', svgPath: MexicoFlag },
  { code: '+691', svgPath: MicronesiaFlag },
  { code: '+373', svgPath: MoldovaFlag },
  { code: '+377', svgPath: MonacoFlag },
  { code: '+976', svgPath: MongoliaFlag },
  { code: '+382', svgPath: MontenegroFlag },
  { code: '+1664', svgPath: MontserratFlag },
  { code: '+258', svgPath: MozambiqueFlag },
  { code: '+95', svgPath: MyanmarFlag },
  { code: '+264', svgPath: NamibiaFlag },
  { code: '+674', svgPath: NauruFlag },
  { code: '+977', svgPath: NepalFlag },
  { code: '+31', svgPath: NetherlandsFlag },
  { code: '+687', svgPath: NewCaledoniaFlag },
  { code: '+505', svgPath: NicaraguaFlag },
  { code: '+227', svgPath: NigerFlag },
  { code: '+234', svgPath: NigeriaFlag },
  { code: '+683', svgPath: NiueFlag },
  { code: '+672', svgPath: NorfolkIslandFlag },
  { code: '+1670', svgPath: NorthernMarianaIslandsFlag },
  { code: '+968', svgPath: OmanFlag },
  { code: '+92', svgPath: PakistanFlag },
  { code: '+680', svgPath: PalauFlag },
  { code: '+970', svgPath: PalestineFlag },
  { code: '+507', svgPath: PanamaFlag },
  { code: '+675', svgPath: PapuaNewGuineaFlag },
  { code: '+595', svgPath: ParaguayFlag },
  { code: '+51', svgPath: PeruFlag },
  { code: '+63', svgPath: PhilippinesFlag },
  { code: '+64', svgPath: NewZealandFlag },
  { code: '+48', svgPath: PolandFlag },
  { code: '+351', svgPath: PortugalFlag },
  { code: '+1939', svgPath: PuertoRicoFlag },
  { code: '+1787', svgPath: PuertoRicoFlag },
  { code: '+974', svgPath: QatarFlag },
  { code: '+40', svgPath: RomaniaFlag },
  { code: '+7', svgPath: RussiaFlag },
  { code: '+250', svgPath: RwandaFlag },
  { code: '+262', svgPath: ReunionFlag },
  { code: '+290', svgPath: SaintHelenaFlag },
  { code: '+1869', svgPath: SaintKittsAndNevisFlag },
  { code: '+1758', svgPath: SaintLuciaFlag },
  { code: '+590', svgPath: SaintMartinFlag },
  { code: '+508', svgPath: SaintPierreAndMiquelonFlag },
  { code: '+1784', svgPath: SaintVincentAndTheGrenadinesFlag },
  { code: '+685', svgPath: SamoaFlag },
  { code: '+378', svgPath: SanMarinoFlag },
  { code: '+239', svgPath: SaoTomeAndPrincipeFlag },
  { code: '+221', svgPath: SenegalFlag },
  { code: '+381', svgPath: SerbiaFlag },
  { code: '+248', svgPath: SeychellesFlag },
  { code: '+232', svgPath: SierraLeoneFlag },
  { code: '+65', svgPath: SingaporeFlag },
  { code: '+1721', svgPath: SintMaartenFlag },
  { code: '+421', svgPath: SlovakiaFlag },
  { code: '+386', svgPath: SloveniaFlag },
  { code: '+677', svgPath: SolomonIslandsFlag },
  { code: '+252', svgPath: SomaliaFlag },
  { code: '+27', svgPath: SouthAfricaFlag },
  { code: '+500', svgPath: FalklandIslandsFlag },
  { code: '+211', svgPath: SouthSudanFlag },
  { code: '+34', svgPath: SpainFlag },
  { code: '+94', svgPath: SriLankaFlag },
  { code: '+249', svgPath: SudanFlag },
  { code: '+597', svgPath: SurinameFlag },
  { code: '+47', svgPath: NorwayFlag },
  { code: '+268', svgPath: SwazilandFlag },
  { code: '+46', svgPath: SwedenFlag },
  { code: '+41', svgPath: SwitzerlandFlag },
  { code: '+963', svgPath: SyriaFlag },
  { code: '+886', svgPath: TaiwanFlag },
  { code: '+992', svgPath: TajikistanFlag },
  { code: '+255', svgPath: TanzaniaFlag },
  { code: '+66', svgPath: ThailandFlag },
  { code: '+599', svgPath: BonaireSintEustatiusAndSabaFlag },
  { code: '+670', svgPath: TimorLesteFlag },
  { code: '+228', svgPath: TogoFlag },
  { code: '+690', svgPath: TokelauFlag },
  { code: '+676', svgPath: TongaFlag },
  { code: '+1868', svgPath: TrinidadAndTobagoFlag },
  { code: '+216', svgPath: TunisiaFlag },
  { code: '+90', svgPath: TurkeyFlag },
  { code: '+993', svgPath: TurkmenistanFlag },
  { code: '+1649', svgPath: TurksAndCaicosIslandsFlag },
  { code: '+688', svgPath: TuvaluFlag },
  { code: '+256', svgPath: UgandaFlag },
  { code: '+380', svgPath: UkraineFlag },
  { code: '+598', svgPath: UruguayFlag },
  { code: '+998', svgPath: UzbekistanFlag },
  { code: '+678', svgPath: VanuatuFlag },
  { code: '+58', svgPath: VenezuelaFlag },
  { code: '+84', svgPath: VietnamFlag },
  { code: '+1284', svgPath: BritishVirginIslandsFlag },
  { code: '+1340', svgPath: USVirginIslandsFlag },
  { code: '+681', svgPath: WallisAndFutunaFlag },
  { code: '+212', svgPath: MoroccoFlag },
  { code: '+967', svgPath: YemenFlag },
  { code: '+260', svgPath: ZambiaFlag },
  { code: '+263', svgPath: ZimbabweFlag },
  { code: '+358', svgPath: FinlandFlag }
];
